<mat-drawer-container>
  <mat-drawer-content>
    <div class="content">
      <!-- Header -->
      <div class="header">
        <!-- Title -->
        <div class="title">
          <h1>Sheets</h1>
        </div>

        <!-- Main actions -->
        <div class="main-actions">
          <!-- Add task button -->
          <button
            class="add-task"
            mat-flat-button
            [color]="'primary'"
            (click)="openSheetTemplateDialog()"
            [matTooltip]="'Shortcut: Ctrl + /'"
          >
            <mat-icon [svgIcon]="'add'"></mat-icon>
            Add Sheet
          </button>
        </div>
      </div>

      <div class="contacts-list">
        <div class="table-wrapper">
          <div class="inline-table-wrapper">
            <ng-container *ngIf="projectSheetsCount > 0; else noContacts">
              <!-- Table -->
              <table
                mat-table
                matSort
                [matSortActive]="'name'"
                [matSortDisableClear]="true"
                [matSortDirection]="'asc'"
                [dataSource]="projectSheets"
                [trackBy]="trackByFn"
              >
                <!-- Name -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let projectSheet">
                    <div class="name-content">
                      <span class="name"
                        ><a [routerLink]="['./' + projectSheet.id]">{{ projectSheet.name }}</a></span
                      >
                    </div>
                  </td>
                </ng-container>

                <!-- Email -->
                <ng-container matColumnDef="created_at">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Created</th>
                  <td mat-cell *matCellDef="let projectSheet">
                    {{ projectSheet.created_at | date: 'MMM dd, y' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="updated_at">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Updated</th>
                  <td mat-cell *matCellDef="let projectSheet">
                    {{ projectSheet.updated_at | date: 'MMM dd, y' }}
                  </td>
                </ng-container>
                <!-- Email -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let projectSheet">
                    <div class="flex">
                      <button mat-icon-button class="delete-task" (click)="deleteProjectSheet(projectSheet)">
                        <mat-icon [svgIcon]="'delete'"></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="projectSheetsTableColumns; sticky: true"></tr>
                <tr class="contact-row" mat-row *matRowDef="let projectSheet; columns: projectSheetsTableColumns"></tr>
              </table>
            </ng-container>
          </div>

          <ng-template #noContacts>
            <div class="no-contacts">There are no sheets!</div>
          </ng-template>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<span #emptyItem></span>
